import { useState } from "react";
import { categories } from "@/mocks/news";

const FORM_SUBMIT_ADDR = "https://readdy.ai/api/form/daioaiboh653ivfvohg0";

interface FormResponse {
  code?: string;
  message?: string;
  meta?: {
    message?: string;
    detail?: string;
  };
}

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const formData = new FormData(formEl);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === "website_alt") return;
      const text = String(value).trim();
      if (!text) return;
      payload.append(key, text);
    });

    setLoading(true);
    setFormError("");
    try {
      const response = await fetch(FORM_SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: FormResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as FormResponse;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const isOk = response.ok && parsed?.code === "OK";

      if (isOk) {
        setStatus("success");
        formEl.reset();
      } else {
        setStatus("error");
        setFormError(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      id="subscribe-form-51cg"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
      noValidate
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <select
          name="topic"
          aria-label="关注栏目"
          className="h-11 w-full shrink-0 cursor-pointer rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-800 outline-none focus:border-primary-400 sm:w-40"
        >
          <option value="全部栏目">全部栏目</option>
          {categories.map((item) => (
            <option key={item.slug} value={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        <div className="flex h-11 flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3">
          <i className="ri-mail-line text-base text-foreground-500" />
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="输入邮箱，第一时间收到今日速递"
            aria-label="邮箱地址"
            className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="h-11 shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? "提交中…" : "立即订阅"}
        </button>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="field-aux-note"
      />

      {status === "success" && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-secondary-700">
          <i className="ri-checkbox-circle-fill" />
          订阅成功，今天的速递会发到你的邮箱。
        </p>
      )}
      {status === "error" && (
        <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-600">
          <i className="ri-error-warning-fill" />
          {formError}
        </p>
      )}
    </form>
  );
}